import { useIsBelow } from './useMediaQuery';

/** True while the viewport is narrower than `threshold` px (default: the `lg` breakpoint). */
const useViewport = (threshold = 1024) => useIsBelow(threshold);

export default useViewport;
